import { windowConfigActions } from './actions';
import { getType } from 'typesafe-actions';
export var initialState = {
  viewportWidth: 0,
  isMobile: false
};
export var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(windowConfigActions.adjustViewport):
      var _action$payload = action.payload,
          isMobile = _action$payload.isMobile,
          viewportWidth = _action$payload.viewportWidth;
      return {
        viewportWidth: viewportWidth,
        isMobile: isMobile
      };

    default:
      return state;
  }
};